import React from "react";
import { MessageDescriptor, useIntl } from "react-intl";

export function useFormatMessageMap(): (
	messages: { [key: string]: MessageDescriptor },
	key: string,
	values?: { [key: string]: any }
) => string {
	const { formatMessage } = useIntl();
	return React.useCallback(
		(messages, key, values) => {
			if (key in messages) {
				return formatMessage(messages[key], values);
			}
			console.error("message not found", { messages, key });
			return key;
		},
		[formatMessage]
	);
}

export function useFormatMessageMapWithoutWarning(): (
	messages: { [key: string]: MessageDescriptor },
	key: string,
	values?: { [key: string]: any }
) => string {
	const { formatMessage } = useIntl();
	return React.useCallback(
		(messages, key, values) => {
			if (key in messages) {
				return formatMessage(messages[key], values);
			}
			return key;
		},
		[formatMessage]
	);
}
